module.exports = __webpack_public_path__ + "static/media/Avatar4.28cd950d.svg";